// extracted by mini-css-extract-plugin
export default {"container":"CookieConsent_container__oOlyj","text":"CookieConsent_text__qQ5pe","button":"CookieConsent_button__vvtBg"};